import { faFlag } from "@elynx/free-solid-svg-icons";
import { ICellRendererParams } from "ag-grid-community";
import { Box, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRouteContext } from "../../../hooks/use-route-context/UseRouteContext";
import { format } from "date-fns";
import { routes } from "../../../routes/routes";
import { UIViewEnum } from "../../../common/enums/UIViewEnum";
import { getDeviceRoute, getWellRoute } from "../../../common/utilities/RouteHelpers";
import storageService from "../../../services/storage/storage-service/StorageService";
import useNavigateTo, { NavigateToOptions } from "../../../hooks/use-navigate-to/useNavigateTo";
import { NewViewTypeEnum } from "../../../common/enums/NewViewTypeEnum";


export function MemoCellRenderer({
    value,
    data
}: ICellRendererParams) {
    const routeContext = useRouteContext();
    const navigateTo = useNavigateTo();

    const onLinkClicked = (shiftKey: boolean, ctrlKey: boolean) => {

        let options: NavigateToOptions | undefined;

        if (shiftKey || ctrlKey) {
            options = {
                newViewType: shiftKey ? NewViewTypeEnum.NewWindow : NewViewTypeEnum.NewTab
            }
        }


        const viewID = data?.wellID ?
            UIViewEnum.Well_Details_History :
            UIViewEnum.Device_Details_History;

        const item = routes.find(o => o.viewID === viewID);

        let url: string | undefined;

        if (data?.deviceID) {

            url = getDeviceRoute(item?.viewID as UIViewEnum,
                routeContext.groupID,
                routeContext.wellID,
                data.deviceID);
        } else if (data?.wellID) {
            url = getWellRoute(item?.viewID as UIViewEnum,
                routeContext.groupID,
                data.wellID);
        }

        if (url) {
            // allow the view to scroll to memo
            storageService.session.set("memoID", data?.memoID);
            navigateTo(url, options);
        }
    }

    const tooltip = value
        ? <Stack direction="column">
            <Typography variant="caption">{data?.memoText}</Typography>
            <Typography variant="caption">{data?.memoCreatedBy}</Typography>
            <Typography variant="caption">{format(new Date(data?.memoTimestamp), "P pp")}</Typography>
        </Stack>
        : ""

    return (value
        ? <Box>
            <Tooltip title={tooltip} placement='bottom-end'>
                <IconButton
                    sx={{
                        fontSize: '1em',
                        padding: 0
                    }}
                    onClick={(ev) => onLinkClicked(ev.shiftKey, ev.ctrlKey)}
                >
                    <FontAwesomeIcon
                        icon={faFlag}
                        fixedWidth={true}
                    />
                </IconButton>
            </Tooltip>
        </Box>
        : undefined
    )
}

